import { styled } from '@material-ui/core/styles';

export const LoaderContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(0, 1.5, 1, 1)
}));
